"use client";

import Link from "next/link";
import React from "react";
import { Button } from "./ui/button";
import { motion } from "motion/react";
import { GraduationCap } from "lucide-react";
import { usePathname } from "next/navigation";

export default function FloatingAdmission() {
  const path = usePathname().split("/")[1]; // Get the first segment of the path
  console.log(path);
  if (path === "online-admission") {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 max-sm:right-10 max-sm:max-w-[360px] z-30">
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.5, type: "spring" }}
        whileHover={{
          scale: 1.05,
          rotate: 3,
          transition: { duration: 0.3, ease: "easeInOut" },
        }}
        whileTap={{
          scale: 0.95,
          rotate: 6,
          transition: { duration: 0.3, ease: "easeInOut" },
        }}
      >
        <Link href="/online-admission" className="relative block">
          <span className="absolute -top-3 -right-2 flex h-5 w-auto items-center justify-center rounded-full bg-destructive px-2 text-[10px] font-bold text-destructive-foreground animate-bounce z-10 whitespace-nowrap">
            2083 Open
          </span>
          <Button
            size="lg"
            className="rounded-full shadow-lg flex items-center gap-2 px-6 bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            <GraduationCap className="h-5 w-5" />
            <span className="font-semibold">Apply Now</span>
          </Button>
        </Link>
      </motion.div>
    </div>
  );
}
